const groups = [
    {
        name: 'Structure',
        features: [
            {
                type: 'label',
                name: 'Label',
                icon: 'tag',
            },
            {
                type: 'rectangle',
                preset: 'line',
                name: 'Line',
                icon: 'horizontal-rule',
            },
            {
                type: 'rectangle',
                preset: 'whiteout',
                name: 'Whiteout',
                icon: 'rectangle-wide',
            },
            {
                type: 'link',
                name: 'Link',
                icon: 'link',
            }
        ]
    },
    {
        name: 'Fields',
        features: [
            {
                type: 'textbox',
                name: 'Textbox',
                icon: 'i-cursor',
            },
            {
                type: 'checkbox',
                name: 'Checkbox',
                icon: 'check-square',
            },
            {
                type: 'dropdown',
                name: 'Dropdown Menu',
                icon: 'chevron-circle-down',
            },
            {
                type: 'date',
                name: 'Date Chooser',
                icon: 'calendar-alt',
            },
            {
                type: 'date',
                preset: 'time',
                name: 'Time Chooser',
                icon: 'clock'
            }
        ]
    },
    {
        name: 'Signature',
        features: [
            {
                type: 'signature',
                name: 'Signature',
                icon: 'file-signature',
            },
            {
                type: 'signature',
                preset: 'initials',
                name: 'Initials',
                icon: 'signature',
            }
        ]
    }
];

const childFeatures = {
    signature: [
        {
            type: 'sigdate',
            name: 'Date',
            icon: 'calendar-alt'
        },
        {
            type: 'sigdate',
            preset: 'signame',
            name: 'Name',
            icon: 'file-signature'
        }
    ]
};

const groupColors = [
    'rgb(239, 68, 68)', // red
    'rgb(245, 188, 11)', // yellow
    'rgb(16, 185, 129)', // green
    'rgb(59, 130, 246)', // blue
    'rgb(149, 92, 246)', // purple
    'rgb(236, 72, 153)', // pink
    'rgb(245, 108, 1)', // orange
    'rgb(17, 164, 188)', // teal
    'rgb(143, 188, 17)', // chartreuse
    'rgb(201, 96, 50)', // brown
];

function getGroupColor(index) {
    if (isNaN(index) || index < 0) return '#667';
    return groupColors[index % groupColors.length];
}

function get(features, featureGroups) {
    let childGroups = [];
    for (let feature of features) {
        if (!childFeatures[feature.type]) continue;
        let color = featureGroups[feature.groupId] ? featureGroups[feature.groupId].color : -1;
        childGroups.push({
            name: feature.name,
            features: childFeatures[feature.type],
            color: getGroupColor(color),
            groupId: feature.groupId
        });
    }
    return groups.concat(childGroups);
}

export default {
    get,
    getGroupColor,
    childFeatures
};